import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { TabItem } from 'src/app/utility/model/tab';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnChanges {
  @Input() tabItems: TabItem[] = [];
  @Input() currentSelectedValue: any;
  @Input() tabAsFilter: boolean = false; // true = filter mode, false = navigation mode
  @Output() selectedTab: EventEmitter<TabItem> = new EventEmitter<TabItem>();

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['currentSelectedValue'] &&
      this.currentSelectedValue !== undefined
    ) {
      this.setActiveTab(this.currentSelectedValue);
    }
  }

  tabClicked(item: TabItem) {
    item.active = true;
    this.tabItems = this.tabItems.map((tab) => ({
      ...tab,
      active: tab.value === item.value,
    }));

    if (this.tabAsFilter) {
      this.selectedTab.emit(item);
    } else if (item?.link) {
      this.router.navigate([item.link], {
        queryParams: item.queryParam || {},
      });
    }
  }

  setActiveTab(value: any) {
    const selectedValue = value ?? '';
    this.tabItems = this.tabItems.map((tab) => ({
      ...tab,
      active: tab.value === selectedValue,
    }));
  }
}
